/*
    Menu tata usaha sama seperti dekan, pakai component dekan namun url tata usaha
*/

export default [
  /**
   *  KURIKULUM
   */
  {
    path: "/tu/kurikulum",
    name: "tu-kurikulum",
    component: () => import("../../views/dekan/kurikulum/Kurikulum.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Tata Usaha", url: "/submenu/tata-usaha" },
        { title: "Kurikulum", active: true },
      ],
      pageTitle: "Kurikulum",
    },
  },

  {
    path: "/tu/kurikulum/lihat-matakuliah/:kurikulumId",
    name: "tu-kurikulum-matkul",
    component: () =>
      import("../../views/dekan/kurikulum/DetailMatkulKurikulum.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Tata Usaha", url: "/submenu/tata-usaha" },
        { title: "Kurikulum", url: "/tata-usaha/kurikulum" },
        { title: "Detail Mata Kuliah", active: true },
      ],
      pageTitle: "Detail Mata Kuliah",
    },
  },
  /**
   *  MAHASISWA
   */
  {
    path: "/tu/mahasiswa",
    name: "tu-mahasiswa",
    component: () => import("../../views/dekan/mahasiswa/DataMahasiswa.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Tata Usaha", url: "/submenu/tu" },
        { title: "Mahasiswa", active: true },
      ],
      pageTitle: "Mahasiswa",
    },
  },
  {
    path: "/tu/mahasiswa/perwalian/:mahasiswaId",
    name: "tu-mahasiswa-perwalian",
    component: () => import("../../views/tu/mahasiswa/Perwalian.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Tata Usaha", url: "/submenu/tata-usaha" },
        { title: "Mahasiswa", url: "/tu/mahasiswa" },
        { title: "Perwalian", active: true },
      ],
      pageTitle: "Perwalian",
    },
  },
  /**
   *  DOSEN WALI
   */
  {
    path: "/tu/dosen-wali",
    name: "tu-dosen-wali",
    component: () => import("../../views/dekan/dosen-wali/DosenWali.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Tata Usaha", url: "/submenu/tata-usaha" },
        { title: "Dosen Wali", active: true },
      ],
      pageTitle: "Dosen Wali",
    },
  },
  /**
   *   KELAS
   */
  {
    path: "/tu/kelas",
    name: "tu-kelas",
    component: () => import("../../views/dekan/kelas/PlotKelas.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Tata Usaha", url: "/submenu/tata-usaha" },
        { title: "Plot Kelas", active: true },
      ],
      pageTitle: "Plot Kelas",
    },
  },

  /**
   *  REKAP PERKULIAHAN
   */

  {
    path: "/tu/rekap-perkuliahan",
    name: "tu-rekap-perkuliahan",
    component: () =>
      import("../../views/dekan/rekap-perkuliahan/RekapPerkuliahan.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Tata Usaha", url: "/submenu/tata-usaha" },
        { title: "Rekap Perkuliahan", active: true },
      ],
      pageTitle: "Rekap Perkuliahan",
    },
  },

  /**
   *  JADWAL MENGAJAR DOSEN
   */

  {
    path: "/tu/jadwal-mengajar",
    name: "tu-jadwal-mengajar",
    component: () => import("../../views/tu/JadwalMengajar.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Tata Usaha", url: "/submenu/tata-usaha" },
        { title: "Jadwal Mengajar", active: true },
      ],
      pageTitle: "Jadwal Mengajar",
    },
  },
  {
    path: "/tu/jadwal-mengajar/sunting/:jadwalId",
    name: "tu-jadwal-mengajar-sunting",
    component: () => import("../../views/tu/EditJadwal.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Tata Usaha", url: "/submenu/tata-usaha" },
        { title: "Jadwal Mengajar", url: "/tata-usaha/jadwal-mengajar" },
        { title: "Sunting Jadwal Mengajar", active: true },
      ],
      pageTitle: "Sunting Jadwal Mengajar",
    },
  },

  {
    path: "/tu/nilai-presensi",
    name: "nilai-presensi",
    component: () => import("../../views/tu/NilaiPresensi.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Tata Usaha", url: "/submenu/nilai-presensi" },
        { title: "Nilai Dan Presensi", active: true },
      ],
      pageTitle: "Nilai Dan Presensi",
    },
  },
  {
    path: "/tu/kerjasama",
    name: "tu-kerjasama",
    component: () => import("../../views/tu/kerjasama/Kerjasama.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Tata Usaha", url: "/submenu/tata-usaha" },
        { title: "Kerjasama", active: true },
      ],
      pageTitle: "Kerjasama",
    },
  },
  {
    path: "/tu/kerjasama/moa",
    name: "tu-kerjasama-moa",
    component: () => import("../../views/tu/kerjasama/moa/TuMoa.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Tata Usaha", url: "/submenu/tata-usaha" },
        { title: "Kerjasama", url: "/tu/kerjasama" },
        { title: "MoA", active: true },
      ],
      pageTitle: "MoA",
    },
  },
  {
    path: "/tu/kerjasama/moa/tambah",
    name: "tu-kerjasama-moa-tambah",
    component: () => import("../../views/tu/kerjasama/moa/TambahMoa.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Tata Usaha", url: "/submenu/tata-usaha" },
        { title: "Kerjasama", url: "/tu/kerjasama" },
        { title: "MoA", url: "/tu/kerjasama/moa/tambah" },
        { title: "Tambah MoA", active: true },
      ],
      pageTitle: "Tambah MoA",
    },
  },
  {
    path: "/tu/kerjasama/moa/pihak-terkait/:moaId",
    name: "tu-kerjasama-moa-pihak-terkait",
    component: () => import("../../views/tu/kerjasama/moa/MoaPihakTerkait.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Tata Usaha", url: "/submenu/tata-usaha" },
        { title: "Kerjasama", url: "/tu/kerjasama" },
        { title: "MoA", url: "/tu/kerjasama/moa" },
        { title: "Pihak Terkait", active: true },
      ],
      pageTitle: "Pihak Terkait",
    },
  },
  {
    path: "/tu/kerjasama/moa/:moaId/dokumen",
    name: "tu-kerjasama-moa-dokumen",
    component: () =>
      import("../../views/tu/kerjasama/moa/TambahDokumenPendukung.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Tata Usaha", url: "/submenu/tata-usaha" },
        { title: "Kerjasama", url: "/tu/kerjasama" },
        { title: "MoA", url: "/tu/kerjasama/moa" },
        { title: "Dokumen Pendukung", active: true },
      ],
      pageTitle: "Dokumen Pendukung",
    },
  },

  {
    path: "/tu/kerjasama/moa/:moaId/edit",
    name: "tu-kerjasama-moa-edit",
    component: () => import("../../views/tu/kerjasama/moa/EditMoa.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Tata Usaha", url: "/submenu/tata-usaha" },
        { title: "Kerjasama", url: "/tu/kerjasama" },
        { title: "MoA", url: "/tu/kerjasama/moa" },
        { title: "Edit MoA", active: true },
      ],
      pageTitle: "Edit MoA",
    },
  },

  {
    path: "/tu/kerjasama/moa/:moaId/detail",
    name: "tu-kerjasama-moa-detail",
    component: () => import("../../views/tu/kerjasama/moa/DetailMoa.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Tata Usaha", url: "/submenu/tata-usaha" },
        { title: "Kerjasama", url: "/tu/kerjasama" },
        { title: "MoA", url: "/tu/kerjasama/moa" },
        { title: "Detail MoA", active: true },
      ],
      pageTitle: "Detail MoA",
    },
  },
  {
    path: "/tu/kerjasama/ia",
    name: "tu-kerjasama-ia",
    component: () => import("../../views/tu/kerjasama/ia/Ia.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Tata Usaha", url: "/submenu/tata-usaha" },
        { title: "Kerjasama", url: "/tu/kerjasama" },
        { title: "IA", active: true },
      ],
      pageTitle: "IA",
    },
  },
  {
    path: "/tu/kerjasama/ia/tambah",
    name: "tu-kerjasama-ia-tambah",
    component: () => import("../../views/tu/kerjasama/ia/TambahIa.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Tata Usaha", url: "/submenu/tata-usaha" },
        { title: "Kerjasama", url: "/tu/kerjasama" },
        { title: "IA", url: "/tu/kerjasama/ia/tambah" },
        { title: "Tambah IA", active: true },
      ],
      pageTitle: "Tambah IA",
    },
  },
  {
    path: "/tu/kerjasama/ia/bentuk-kegiatan/:iaId",
    name: "tu-kerjasama-ia-bentuk-kegiatan",
    component: () => import("../../views/tu/kerjasama/ia/BentukKegiatan.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Tata Usaha", url: "/submenu/tata-usaha" },
        { title: "Kerjasama", url: "/tu/kerjasama" },
        { title: "IA", url: "/tu/kerjasama/ia" },
        { title: "Bentuk Kegiatan", active: true },
      ],
      pageTitle: "Bentuk Kegiatan",
    },
  },
  {
    path: "/tu/kerjasama/ia/pihak-terkait/:iaId",
    name: "tu-kerjasama-ia-pihak-terkait",
    component: () => import("../../views/tu/kerjasama/ia/IaPihakTerkait.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Tata Usaha", url: "/submenu/tata-usaha" },
        { title: "Kerjasama", url: "/tu/kerjasama" },
        { title: "IA", url: "/tu/kerjasama/ia" },
        { title: "Pihak Terkait", active: true },
      ],
      pageTitle: "Pihak Terkait",
    },
  },
  {
    path: "/tu/kerjasama/ia/:iaId/dokumen",
    name: "tu-kerjasama-ia-dokumen",
    component: () =>
      import("../../views/tu/kerjasama/ia/TambahDokumenPendukung.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Tata Usaha", url: "/submenu/tata-usaha" },
        { title: "Kerjasama", url: "/tu/kerjasama" },
        { title: "IA", url: "/tu/kerjasama/ia" },
        { title: "Dokumen Pendukung", active: true },
      ],
      pageTitle: "Dokumen Pendukung",
    },
  },
  {
    path: "/tu/kerjasama/ia/:iaId/edit",
    name: "tu-kerjasama-ia-edit",
    component: () => import("../../views/tu/kerjasama/ia/EditIa.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Tata Usaha", url: "/submenu/tata-usaha" },
        { title: "Kerjasama", url: "/tu/kerjasama" },
        { title: "IA", url: "/tu/kerjasama/ia" },
        { title: "Edit IA", active: true },
      ],
      pageTitle: "Edit IA",
    },
  },
  {
    path: "/tu/kerjasama/ia/:iaId/detail",
    name: "tu-kerjasama-ia-detail",
    component: () => import("../../views/tu/kerjasama/ia/DetailIa.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Tata Usaha", url: "/submenu/tata-usaha" },
        { title: "Kerjasama", url: "/tu/kerjasama" },
        { title: "IA", url: "/tu/kerjasama/ia" },
        { title: "Detail IA", active: true },
      ],
      pageTitle: "Detail IA",
    },
  },

  /**
   *  AKTIVITAS MAHASISWA
   */
  {
    path: "/tu/aktivitas-mahasiswa",
    name: "tu-aktivitas-mahasiswa",
    component: () =>
      import("../../views/tu/aktivitas-mahasiswa/AktivitasMahasiswa.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Tata Usaha", url: "/submenu/tata-usaha" },
        { title: "Aktivitas Mahasiswa", active: true },
      ],
      pageTitle: "Aktivitas Mahasiswa",
    },
  },
  {
    path: "/tu/aktivitas-mahasiswa/tambah-aktivitas",
    name: "tu-aktivitas-mahasiswa-tambah",
    component: () =>
      import("../../views/tu/aktivitas-mahasiswa/TambahAktivitasMahasiswa.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Tata Usaha", url: "/submenu/tata-usaha" },
        { title: "Aktivitas Mahasiswa", url: "/tu/aktivitas-mahasiswa" },
        { title: "Tambah Aktivitas Mahasiswa", active: true },
      ],
      pageTitle: "Tambah Aktivitas Mahasiswa",
    },
  },
  {
    path: "/tu/aktivitas-mahasiswa/edit-aktivitas/:aktivitasId",
    name: "tu-aktivitas-mahasiswa-edit",
    component: () =>
      import("../../views/tu/aktivitas-mahasiswa/EditAktivitasMahasiswa.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Tata Usaha", url: "/submenu/tata-usaha" },
        { title: "Aktivitas Mahasiswa", url: "/tu/aktivitas-mahasiswa" },
        { title: "Edit Aktivitas Mahasiswa", active: true },
      ],
      pageTitle: "Edit Aktivitas Mahasiswa",
    },
  },
  {
    path: "/tu/aktivitas-mahasiswa/tambah-peserta/:aktivitasId",
    name: "tu-aktivitas-mahasiswa-tambah-peserta",
    component: () =>
      import("../../views/tu/aktivitas-mahasiswa/TambahPesertaAktivitas.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Tata Usaha", url: "/submenu/tata-usaha" },
        { title: "Aktivitas Mahasiswa", url: "/tu/aktivitas-mahasiswa" },
        { title: "Tambah Peserta Aktivitas", active: true },
      ],
      pageTitle: "Tambah Peserta Aktivitas",
    },
  },
  {
    path: "/tu/aktivitas-mahasiswa/sunting-peserta/:aktivitasId",
    name: "tu-aktivitas-mahasiswa-sunting-peserta",
    component: () =>
      import("../../views/tu/aktivitas-mahasiswa/EditPesertaAktivitas.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Tata Usaha", url: "/submenu/tata-usaha" },
        { title: "Aktivitas Mahasiswa", url: "/tu/aktivitas-mahasiswa" },
        { title: "Sunting Peserta Aktivitas", active: true },
      ],
      pageTitle: "Sunting Peserta Aktivitas",
    },
  },

  {
    path: "/tu/matakuliah",
    name: "tu-matakuliah",
    component: () => import("../../views/tu/matakuliah/Matakuliah.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Tata Usaha", url: "/submenu/tata-usaha" },
        { title: "Matakuliah", active: true },
      ],
      pageTitle: "Matakuliah",
    },
  },
  {
    path: "/tu/matakuliah/plot-matakuliah",
    name: "tu-matakuliah-plot-matakuliah",
    component: () => import("../../views/tu/matakuliah/PlotMatakuliah.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Tata Usaha", url: "/submenu/tata-usaha" },
        { title: "Plot Matakuliah", active: true },
      ],
      pageTitle: "Plot Matakuliah",
    },
  },
];
